import { Symbiosis } from 'symbiosis-js-sdk'

export const symbiosis = new Symbiosis('mainnet', 'rewards')
